import { config } from '@uhg-abyss/web/tools/config';

import { useCustomQuery } from '../useCustomQuery';
import GET_PROVIDER_DIRECTORY_CNS from './getProviderDirectoryCNSPdfs.graphql';

export const useGetProviderDirectoriesCNS = (options) => {
  const [queryResult, queryAction] = useCustomQuery(
    GET_PROVIDER_DIRECTORY_CNS,
    {
      ...options,
      url: config('GRAPHQL_API_URL'),
      accessor: 'getProviderDirectoryCNS',
      requestPolicy: 'no-cache',
    }
  );
  const parsedResult = {
    ...queryResult,
    data: {
      ...queryResult?.data?.getProviderDirectoryCNS,
    },
  };
  return [parsedResult, queryAction];
};
